import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import FAQ from '../components/FAQ';
import ScrollToTop from '../components/ScrollToTop';
import ScrollReveal from '../components/ScrollReveal';
import './FAQPage.css';

const FAQPage = () => {
  return (
    <>
      <Navbar />
      <ScrollToTop />

      <div className="faq-page">
        <section className="faq-hero">
          <div className="container">
            <ScrollReveal animation="fade-up">
              <h1>Perguntas Frequentes</h1>
            </ScrollReveal>
            <ScrollReveal animation="fade-up" delay={0.2}>
              <p className="faq-subtitle">
                Encontre respostas para as perguntas mais comuns sobre as nossas soluções
              </p>
            </ScrollReveal>
          </div>
        </section>

        <ScrollReveal animation="fade-up" delay={0.3}>
          <FAQ />
        </ScrollReveal>

        <section className="faq-cta">
          <div className="container">
            <ScrollReveal animation="zoom-in">
              <div className="cta-content">
                <h2>Ainda tem dúvidas?</h2>
                <p>A nossa equipa está pronta para ajudar. Entre em contacto connosco!</p>
                <div className="cta-buttons">
                  <a href="/#contact" className="cta-btn primary">
                    Contacte-nos
                  </a>
                  <a href="tel:+351969059898" className="cta-btn secondary">
                    <span className="phone-icon">📞</span> +351 969 059 898
                  </a>
                </div>
              </div>
            </ScrollReveal>
          </div>
        </section>
      </div>

      <Footer />
    </>
  );
};

export default FAQPage;
